import {BaseAddressUnDeletable} from '../../../common/entities';

export class GraduationLocation extends BaseAddressUnDeletable {
    name: string;
}
